import React from "react";
import {
    useTable,
    usePagination,
    useSortBy,
} from "react-table";

const Paginated = ({
    columns,
    data,
    fetchSupportDetails,
    totalCount,
    currentPage,
    pageSize,
    setPageSizeData,
}) => {

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
    } = useTable(
        {
            columns,
            data,
            manualPagination: true,
            pageCount: Math.ceil(totalCount / pageSize),
            initialState: {
                pageIndex: currentPage - 1,
                pageSize: pageSize,
            },
        },
        useSortBy,
        usePagination
    );

    const totalPages = Math.ceil(totalCount / pageSize);

    const handleNext = () => {
        if (currentPage < totalPages) {
            fetchSupportDetails(currentPage + 1, pageSize);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            fetchSupportDetails(currentPage - 1, pageSize);
        }
    };

    const handlePageChange = (e) => {
        fetchSupportDetails(Number(e.target.value), pageSize);
    };

    const handlePageSize = (e) => {
        const size = Number(e.target.value);
        setPageSizeData(size);
        fetchSupportDetails(1, size);
    };

    return (
        <div className="customTable">
            <div className="customTable__header">
                <div className="customTable__left">
                    <div className="customTable__showingRecords">
                        <div className="form-group">
                            <label>Show Records:</label>

                            <select
                                className="form-control selectArrow"
                                value={pageSize}
                                onChange={handlePageSize}
                            >
                                {[10, 25, 50, 100].map((size) => (
                                    <option key={size} value={size}>
                                        {size}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div className="customTable__body">
                <div className="table-responsive">
                    <table
                        className="table table-striped table-bordered"
                        {...getTableProps()}
                    >
                        <thead>
                            {headerGroups.map((headerGroup) => {
                                const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
                                return (
                                    <tr key={key} {...headerGroupProps}>
                                        {headerGroup.headers.map((column) => {
                                            const { key, ...headerProps } = column.getHeaderProps();
                                            return (
                                                <th key={key} {...headerProps}>
                                                    {column.render("Header")}
                                                </th>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </thead>

                        {page?.length ? (
                            <tbody {...getTableBodyProps()}>
                                {page.map((row) => {
                                    prepareRow(row);
                                    const { key, ...rowProps } = row.getRowProps();

                                    return (
                                        <tr key={key} {...rowProps}>
                                            {row.cells.map((cell) => {
                                                const { key, ...cellProps } = cell.getCellProps();
                                                return (
                                                    <td key={key} {...cellProps}>
                                                        {cell.render("Cell")}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan={12}>
                                        <p style={{ textAlign: "center", margin: 0 }}>
                                            No data found
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>

            <div className="customTable__footer">
                <div className="customTable__left">
                    <div className="customTable__totalTransactions">
                        <p>
                            Total Records: <span>{totalCount}</span>
                        </p>
                    </div>
                </div>

                <div className="customTable__right">
                    <div className="customTable__top">
                        <div className="customTable__totalPages">
                            <p>
                                Page

                                <select
                                    className="form-control selectArrow"
                                    value={currentPage}
                                    onChange={handlePageChange}
                                >
                                    {[...Array(totalPages)].map((_, index) => (
                                        <option key={index + 1} value={index + 1}>
                                            {index + 1}
                                        </option>
                                    ))}
                                </select>

                                of <span>{totalPages || 1}</span>
                            </p>
                        </div>
                    </div>

                    <div className="customTable__bottom customTable__bottom__2">
                        <div className="customTable__buttons">

                            <span
                                className={`btn btn-outline-primary ${currentPage === 1 ? "disabled" : ""
                                    }`}
                                onClick={handlePrevious}
                            >
                                Previous
                            </span>

                            <span
                                className={`btn btn-outline-primary ${currentPage === totalPages ? "disabled" : ""
                                    }`}
                                onClick={handleNext}
                            >
                                Next
                            </span>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Paginated;